import { useNavigate } from 'react-router';
import { useModalContext } from 'src/hooks/useModalContext';
import { useRoute } from 'src/router/hooks';

type StartAuthFlowParams = {
  props?: { [key: string]: unknown };
  replace?: boolean;
  defaultFlow?: boolean;
  onSuccess?: () => void;
};

type handleSuccessProps = Omit<StartAuthFlowParams, 'replace' | 'props'>;

/** Отдает функции startLogin и startRegistration с помощью которых можно
 * открыть логин или регистрацию и запланировать действие после успешного завершения
 * аутентификации передав onSuccess. Функции умеют также принимать replace и props
 * для модалок.
 */
export const useAuthFlow = () => {
  const { openModal } = useModalContext();
  const navigate = useNavigate();
  const { ROUTE } = useRoute();

  const handleSuccess = ({ defaultFlow, onSuccess }: handleSuccessProps) => {
    if (defaultFlow) {
      return () => navigate(ROUTE.GAMES.get('top'));
    }
    if (onSuccess) {
      return onSuccess;
    }
  };

  const startLogin = ({ props = {}, replace, onSuccess }: StartAuthFlowParams = {}) => {
    openModal('LOGIN', { props: { ...props, onAuthFlowSuccess: onSuccess }, replace });
  };

  const startRegistration = ({
    props = {},
    replace,
    onSuccess,
    defaultFlow = false
  }: StartAuthFlowParams = {}) => {
    openModal('SIGNUP', {
      props: {
        ...props,
        onAuthFlowSuccess: handleSuccess({ defaultFlow, onSuccess })
      },
      replace
    });
  };

  return {
    startLogin,
    startRegistration
  };
};
